import { render, staticRenderFns } from "./ConfirmCodeView.vue?vue&type=template&id=2be61b7c&scoped=true&"
import script from "./ConfirmCodeView.vue?vue&type=script&lang=ts&"
export * from "./ConfirmCodeView.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmCodeView.vue?vue&type=style&index=0&id=2be61b7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be61b7c",
  null
  
)

export default component.exports